import {
    pdpTradeDesignManagerProOnboardingRule,
    pdpTradeDesignManagerStandardOnboardingRule,
} from '../../../global/tradeOnboarding/tradeDesignManagerOnboardingRules';

import {
    PRIORITIES,
    SHOW_PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING,
    SHOW_PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING,
} from '../pdpSharedNotificationConstants';

export const pdpTradeDesignManagerProOnboardingModalConfig = {
    name: 'pdpTradeDesignManagerProOnboardingModal',
    priority: PRIORITIES.PDP_TRADE_DESIGN_MANAGER_ONBOARDING,
    rule: pdpTradeDesignManagerProOnboardingRule,
    action: () => dispatch =>
        dispatch({
            type: SHOW_PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING,
        }),
};

export const pdpTradeDesignManagerStandardOnboardingModalConfig = {
    name: 'pdpTradeDesignManagerStandardOnboardingModal',
    priority: PRIORITIES.PDP_TRADE_DESIGN_MANAGER_ONBOARDING,
    rule: pdpTradeDesignManagerStandardOnboardingRule,
    action: () => dispatch =>
        dispatch({
            type: SHOW_PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING,
        }),
};
